export default __webpack_public_path__ + "static/media/group-3-one-nhl.d6663fb6.png";